// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gif-modal-ui{z-index:9999}.loader-wrapper{align-items:center;display:flex;justify-content:center;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);z-index:50}.ui-modal.ui-gif-picker{align-items:stretch;bottom:0;display:flex;flex-direction:column;justify-content:flex-start;left:0;padding:0;position:fixed;right:0;top:0;z-index:9999}@media (min-width:768px){.ui-modal.ui-gif-picker{border-radius:24px;bottom:auto;height:auto;left:auto;left:50%;overflow:hidden;padding-bottom:24px;right:auto;top:auto;top:50%;transform:translate(-50%,-50%);width:600px}}.ui-gif-picker{width:600px}.ui-gif-picker .formulate-input{margin:0}.ui-gif-picker .formulate-input[data-classification=text] input{background:transparent;border:none;box-shadow:none;font-size:1rem;height:100%;line-height:3rem;outline:none}.ui-gif-picker .gif-row{display:flex;flex:1;gap:4px;max-height:500px;overflow-y:auto;padding-bottom:24px;position:relative}.ui-gif-picker .gif-row.loading-height{min-height:500px}.ui-gif-picker .gif-row::-webkit-scrollbar{display:none;height:0;width:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"a": "#5a80fb",
	"b": "#6b88fc",
	"c": "#7b91fc",
	"d": "#8899fd",
	"e": "#95a2fd",
	"f": "#a1abfe",
	"g": "#adb4fe",
	"h": "#b8bdfe",
	"i": "#c3c6ff",
	"j": "#cdcfff",
	"k": "#d8d9ff",
	"l": "#e2e2ff",
	"m": "#ececff",
	"n": "#f5f5ff",
	"o": "#fff"
};
module.exports = ___CSS_LOADER_EXPORT___;
